<template>
  <div class="filters">
    <app-prices />
    <app-discounts />
    <app-tags />
    <app-attributes />
  </div>
</template>

<script>
import Tags from "./filter/Tags.vue";
import Attributes from "./filter/Attributes.vue";
import Prices from "./filter/Prices.vue";
import Discounts from "./filter/Discounts.vue";

export default {
  components: {
    appAttributes: Attributes,
    appTags: Tags,
    appPrices: Prices,
    appDiscounts: Discounts
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Filters.vue